// Spec 45 component-behavior — cmp_ds_badge.
//
// Tone-driven visual indicator (status pill). Variants map to spec 49
// tone matrix surfaces: info / success / warning / danger / neutral /
// accent. Sizes: sm / md.
//
// Decorative-only by default — caller supplies aria-label when the
// badge carries semantic information not in surrounding text (e.g.,
// status indicator next to an avatar). When the badge IS the only
// affordance for state ("3 unread"), wrap in a span with role="status"
// + aria-live='polite' at the consumer level.

import { forwardRef, type HTMLAttributes } from "react";

import { cx } from "../lib/cx.ts";

export type BadgeTone =
  | "neutral"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "accent";

export type BadgeSize = "sm" | "md";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  readonly tone?: BadgeTone;
  readonly size?: BadgeSize;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ tone = "neutral", size = "md", className, ...rest }, ref) => (
    <span
      ref={ref}
      data-component="badge"
      data-tone={tone}
      data-size={size}
      className={cx("nai-badge", className)}
      {...rest}
    />
  ),
);
Badge.displayName = "Badge";
